import React from "react";
import { toast, ToastOptions } from "react-toastify";

interface LastToastInfo {
  message: string;
  timestamp: number;
}

let lastErrorToast: LastToastInfo | null = null;
const DEBOUNCE_TIME = 2000; // 2 seconds

/**
 * Shows an error toast, preventing duplicate messages within the debounce time
 * @param message - The error message to display
 * @param options - Optional toast options
 */
export const showErrorToast = (
  message: string | React.ReactNode,
  options?: ToastOptions,
): void => {
  const messageStr = typeof message === "string" ? message : String(message);
  const now = Date.now();

  // Check if the same message was shown recently
  if (
    lastErrorToast &&
    lastErrorToast.message === messageStr &&
    now - lastErrorToast.timestamp < DEBOUNCE_TIME
  ) {
    // Duplicate message within debounce time, skip it
    return;
  }

  // Update last toast info
  lastErrorToast = {
    message: messageStr,
    timestamp: now,
  };

  // Show the toast
  toast.error(message, options);
};
